import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X, ArrowRight } from "lucide-react";

// Dismissible, logged-out-only promo for the Closer Quiz.
// variant="banner", slim full-width strip (landing). variant="card", compact card (signup pages).
export function QuizPromo({ variant = "banner" }) {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  if (variant === "card") {
    return (
      <div className="relative rounded-2xl bg-gradient-to-br from-violet-600/20 to-emerald-500/10 border border-violet-400/30 p-4 mb-5" data-testid="quiz-promo-card">
        <button onClick={() => setOpen(false)} data-testid="quiz-promo-dismiss" className="absolute top-2.5 right-2.5 text-slate-400 hover:text-white"><X className="w-4 h-4" /></button>
        <p className="text-sm font-bold text-white flex items-center gap-1.5"><Sparkles className="w-4 h-4 text-violet-300" /> Not sure where you fit?</p>
        <p className="text-xs text-slate-300 mt-1">Take the free 2-minute quiz to find your closer type.</p>
        <Link to="/closer-quiz" data-testid="quiz-promo-link" className="inline-flex items-center gap-1 text-sm font-bold text-emerald-300 hover:text-emerald-200 mt-2">What kind of closer are you? <ArrowRight className="w-3.5 h-3.5" /></Link>
      </div>
    );
  }

  return (
    <div className="relative h-full bg-gradient-to-r from-violet-600/25 via-violet-500/12 to-transparent border-b border-white/10" data-testid="quiz-promo-banner">
      <Link to="/core-assessment" data-testid="quiz-promo-link" className="flex items-center justify-center gap-2 px-6 h-full min-h-[52px] text-center hover:from-violet-600/35 transition-colors">
        <Sparkles className="w-4 h-4 text-violet-200 shrink-0" />
        <p className="text-sm text-white/90 font-semibold leading-tight">
          New: <span className="font-extrabold text-white">Take the free C.O.R.E. assessment</span> and attract high-paying sales careers →
        </p>
      </Link>
    </div>
  );
}
